// /utils/orderPayload.js

/**
 * Generate order payload for real or virtual brokers.
 *
 * @param {'real'|'virtual'} isVirtual - Mode to determine broker type.
 * @param {Array} selectedData - List of selected order data.
 * @param {string} marketType - Either "NRML" or another type.
 * @param {Object} limitOrderStates - Order type (MARKET/LIMIT) state per symbol.
 * @param {Object} selectedSymbol - Selected symbol info.
 * @param {string} broker - Broker name for real orders.
 * @param {string} access_token - Auth token.
 * @param {string} client_id - Client ID.
 * @returns {Object} Final payload to send.
 */
const generateOrderPayload = ({
    isVirtual = false,
    selectedData,
    marketType,
    limitOrderStates,
    selectedSymbol,
    broker,
    access_token,
    client_id,
}) => {
    const orderList = selectedData.map((currData, ind) => ({
        isBuy: currData.isBuy,
        isCall: currData.isCALL,
        isFut: false,
        code: currData.code,
        exchange: currData.exchange,
        productType: marketType === 'NRML' ? 'NRML' : 'MIS',
        orderType: !limitOrderStates?.[selectedSymbol?.scrip]?.[ind] ? 'MARKET' : 'LIMIT',
        quantity: currData.lotSize * currData.lot_multiplier,
        price: currData.price,
        freeze_qty: currData.freeze_qty,
        strike: currData.strike,
        expiry: currData.expiry,
        tradingSymbol: currData.tradingSymbol,
        lot_multiplier: currData.lot_multiplier,
        scrip: currData.scrip,
    }));

    const payload = {
        order_list: orderList,
        broker: isVirtual ? 'virtual' : broker,
        access_token,
        client_id,
    };

    return payload;
};

export default generateOrderPayload;
